const questionFilter = (question) =>
  !question.isHidden() &&
  !question.isHiddenInNavigationUI() &&
  // Skip questions with empty descriptions
  !(question.isSection() && !question.getDescription());

export default questionFilter;
